import { Controller } from "@hotwired/stimulus";

// The "Compare Products" strip on GPL search. The compare toggles and bar are React islands that
// announce the compared list on window (components/gpl/events.ts), so this follows the same
// event: the badge shows the count and the strip hides with nothing compared.
export default class extends Controller {
  static targets = ["count"];

  update({ detail }) {
    if (!Array.isArray(detail?.uuids)) return;

    const count = detail.uuids.length;
    this.countTarget.textContent = count;
    this.element.classList.toggle("d-none", count === 0);
  }
}
